import { initializeIntl, initializeLogging, initializeSession, initializeTarget } from ".";

type TUnpacked<T> = T extends (infer U)[]
  ? U
  : T extends (...args: unknown[]) => infer U
    ? U
    : T extends Promise<infer U>
      ? U
      : T;

export default async function promiseBootstrap(): Promise<{
  target: TUnpacked<ReturnType<typeof initializeTarget>>;
  intl: TUnpacked<ReturnType<typeof initializeIntl>>;
  session: TUnpacked<ReturnType<typeof initializeSession>>;
}> {
  const target = await initializeTarget();
  const session = await initializeSession(target);
  const intl = await initializeIntl(session);
  await initializeLogging(session, target);

  return { target, session, intl };
}
